<template>
  <div class="p-anken-index__detail" v-bind:class="{ 'is-contact': job.is_contact }">
      <div class="p-anken-index__detail__top">
        <p><span class="number">No.{{ formartNo(job.id.toString()) }}</span>更新日<span class="day">{{ formatDate(job.created_at) }}</span></p>
        <p v-if="user" class="star_logo" @click="bookmark(job.id)">
          <img v-if="is_bookmark == false"src="/images/pc/anken_detail_star1.png" alt="star">
          <img v-if="is_bookmark == true" src="/images/pc/anken_detail_star2.png" alt="star">
        </p>
      </div>
      <p class="p-anken-index__detail__title bold">{{job.name}}</p>
      <div class="p-anken-index__detail__list">
        <p><img :src="'/images/' + imageType + '/anken_detail_yen.png'" alt=""></p>
        <p><span class="bold mr25">{{formatPrice(job.price_from)}} 〜{{formatPrice(job.price_to)}}</span><span class="mr25">／月</span>{{job.deal_type}}</p>
      </div>
      <div class="p-anken-index__detail__list">
        <p><img :src="'/images/' + imageType + '/anken_detail_spot.png'" alt=""></p>
        <p><span class="bold">{{job.place}}</span></p>
      </div>
      <div class="p-anken-index__detail__list">
        <p><img :src="'/images/' + imageType + '/anken_detail_schedule.png'" alt=""></p>
        <p><span class="bold mr25">{{job.join}}</span></p>
      </div>
      <div class="p-anken-index__detail__list">
        <p><img :src="'/images/' + imageType + '/anken_detail_skill.png'" alt=""></p>
        <p>
          <a class="skill skill--link" v-for="(tag, index) in job.tags_link" v-bind:key="`tag-link-${index}`" v-bind:href="`/job/${tag.canonical_name}`">{{tag.name}}</a>
          <span class="skill" v-for="(tag, index) in job.tags_no_link" v-bind:key="`tag-no-link-${index}`">{{tag.name}}</span>
        </p>
      </div>
      <div class="p-anken-index__detail__link"><a :href="'/job/detail/' + job.id ">詳細を見る</a></div>
      <slot></slot>

  </div>
</template>

<script>
import Form from "@/utils/Form";
import { formatPrice, formatDate } from '@/utils/Helper'
import { modalOpen } from '@/utils/Modal'

export default {
  props: {
    data: {
      type: Array | Object | null,
      default: null,
      required: false,
    },
    isMobile : {
      type: Boolean,
      default: false,
      required: false,
    },
    user: {
      type: Array | Object | null,
      default: false,
      required: false,
    }
  },
  components: {
  },
  data() {
    return {
      job: this.data,
      form: new Form({
      }),
      is_bookmark: this.data.is_bookmark,
      imageType: this.isMobile ? 'sp' : 'pc',
      formClass: this.isMobile ? 'o-form__sp' : 'o-form__pc',
      sending: false
    }
  },
  methods: {
    formatPrice(price) {
      return formatPrice(price / 10000) + '万'
    },

    formatDate(date) {
      return formatDate(date, 'YYYY.MM.DD')
    },

    formartNo(str) {
      return str.padStart(7, '0');
    },

    bookmark(jobId) {
      this.form
          .post({
            url: "/job/bookmark/" + jobId,
          })
          .then(({}) => {
            this.is_bookmark = !this.is_bookmark
          })
          .catch((error) => {
          });
    },

    contact(jobId) {
      if (this.sending) {
        return;
      }
      var modalId = "modal-contact-" + jobId
      this.sending = true;
      this.form
          .post({
            url: "/job/contact/" + jobId,
          })
          .then(({data: {data}}) => {
            this.job = data
            this.sending = false
            modalOpen(modalId)
          })
          .catch((error) => {
            this.sending = false
          });
    },
  },
  mounted() {
  },
  computed: {

  }
}
</script>
